import { normalizeAdminMediaUrl } from './adminMediaUrl'

const VIDEO_EXTENSION_PATTERN = /\.(mp4|mov|m4v|avi|webm|mkv)(?=$|[?#&])/i
const MEDIA_OBJECT_KEYS = ['url', 'src', 'path', 'fileUrl', 'previewUrl', 'relativeUrl']
const MEDIA_CONTAINER_KEYS = ['media', 'mediaList', 'files', 'list', 'data', 'result', 'value']

function getMediaValue(item) {
  if (!item || typeof item !== 'object') {
    return item
  }
  for (let index = 0; index < MEDIA_OBJECT_KEYS.length; index += 1) {
    const value = item[MEDIA_OBJECT_KEYS[index]]
    if (value) {
      return value
    }
  }
  return ''
}

function parseAuditMediaItems(value, depth) {
  const currentDepth = Number(depth) || 0
  if (!value || currentDepth > 5) {
    return []
  }
  if (Array.isArray(value)) {
    return value.reduce((result, item) => {
      if (item && typeof item === 'object' && getMediaValue(item)) {
        result.push(item)
        return result
      }
      return result.concat(parseAuditMediaItems(item, currentDepth + 1))
    }, [])
  }
  if (typeof value === 'object') {
    if (getMediaValue(value)) {
      return [value]
    }
    return MEDIA_CONTAINER_KEYS.reduce((result, key) => {
      return result.concat(parseAuditMediaItems(value[key], currentDepth + 1))
    }, [])
  }

  const text = String(value).trim()
  if (!text) {
    return []
  }
  try {
    const parsed = JSON.parse(text)
    if (parsed !== text) {
      return parseAuditMediaItems(parsed, currentDepth + 1)
    }
  } catch (error) {}
  return [text]
}

function normalizeAuditMediaUrl(item) {
  return normalizeAdminMediaUrl(getMediaValue(item))
}

function decodeMediaText(value) {
  let decoded = String(value || '')
  for (let index = 0; index < 2; index += 1) {
    try {
      const nextValue = decodeURIComponent(decoded)
      if (nextValue === decoded) {
        break
      }
      decoded = nextValue
    } catch (error) {
      break
    }
  }
  return decoded
}

function isAuditVideoMedia(item) {
  const url = decodeMediaText(normalizeAuditMediaUrl(item))
  if (VIDEO_EXTENSION_PATTERN.test(url)) {
    return true
  }
  if (!item || typeof item !== 'object') {
    return false
  }
  const hint = [item.type, item.mimeType, item.fileType, item.name, item.fileName]
    .filter(Boolean)
    .join(' ')
  return /(^|[\s/])video([\s/]|$)|\.(mp4|mov|m4v|avi|webm|mkv)$/i.test(hint)
}

function getAdminAuditMediaList(value) {
  const seen = {}
  return parseAuditMediaItems(value).reduce((result, item) => {
    const url = normalizeAuditMediaUrl(item)
    if (!url || seen[url]) {
      return result
    }
    seen[url] = true
    result.push({
      url,
      type: isAuditVideoMedia(item) ? 'video' : 'image'
    })
    return result
  }, [])
}

export {
  getAdminAuditMediaList,
  isAuditVideoMedia,
  normalizeAuditMediaUrl
}



// WEBPACK FOOTER //
// ./src/utils/adminAuditMedia.js